import React, { useRef, useState, useEffect } from "react";
import { aboutUsVision, aboutUsMission } from "../../data/aboutUsContent";
import { FaEye, FaBullseye, FaAmbulance, FaUserMd, FaClock} from "react-icons/fa";
// import ambulanceImg from '../../assets/ambAnimated.png';
import { AboutAmbAnimated } from '../../data/photos';
import {ImageFadeReveal, FadeIn } from "../../utils/AboutUsFadeEffects";

export default function AboutVisionMission() {

  const vision = aboutUsVision;
  const mission = aboutUsMission;
    
  return(
    <>
      <section>
        <div className="flex justify-center">
          <div className="w-auto h-auto rounded-3xl items-center justify-center overflow-hidden">
            <ImageFadeReveal
              src={AboutAmbAnimated}
              alt="Animated Ambulance"
              className="object-contain w-full h-full"
              loading="lazy"
            />
          </div>
        </div>
      </section>
      <section className="py-6 px-2 sm:px-8 max-w-5xl mx-auto grid md:grid-cols-2 gap-10">
        <FadeIn direction="left">
          <div className="flex flex-col items-center bg-white rounded-3xl shadow-lg border border-sky-100 p-8">
            <FaEye className="text-sky-500 text-4xl mb-3" />
            <h3 className="text-xl font-bold text-sky-700 mb-2">Our Vision</h3>
            {vision.map((visionLines, index) => (
              <p
                key={index} 
                className="text-gray-700">
                {visionLines}
              </p>
            ))}
          </div>
        </FadeIn>
        <FadeIn direction="right">
          <div className="flex flex-col items-center bg-white rounded-3xl shadow-lg border border-sky-100 p-8">
            <FaBullseye className="text-sky-500 text-4xl mb-3" />
            <h3 className="text-xl font-bold text-sky-700 mb-2">Our Mission</h3>
            {mission.map((missionLines, index) => (
              <p 
                key={index}
                className="text-gray-700">
                {missionLines}
              </p>
            ))}
          </div>
        </FadeIn>
      </section>


      {/* Features: Alternating fades */}
            <section className="py-10 px-2 sm:px-8 max-w-6xl mx-auto grid md:grid-cols-3 gap-10">
              <FadeIn direction="left">
                <div className="flex flex-col items-center bg-white rounded-3xl shadow-lg border border-sky-100 p-8">
                  <FaAmbulance className="text-sky-600 text-4xl mb-3 mx-auto" />
                  <h3 className="text-lg font-bold text-sky-700 mb-2">Trusted Response</h3>
                  <p className="text-gray-600 text-center">Highly trained crews deploy within minutes, giving you immediate access to emergency care.</p>
                </div>
              </FadeIn>
              <FadeIn direction="bottom">
                <div className="flex flex-col items-center bg-white rounded-3xl shadow-lg border border-sky-100 p-8">
                  <FaUserMd className="text-sky-600 text-4xl mb-3 mx-auto" />
                  <h3 className="text-lg font-bold text-sky-700 mb-2">Compassionate Care</h3>
                  <p className="text-gray-600 text-center">Every patient receives empathetic, professional assistance—your comfort and dignity assured.</p>
                </div>
              </FadeIn>
              <FadeIn direction="right">
                <div className="flex flex-col items-center bg-white rounded-3xl shadow-lg border border-sky-100 p-8">
                  <FaClock className="text-sky-600 text-4xl mb-3 mx-auto" />
                  <h3 className="text-lg font-bold text-sky-700 mb-2">24/7 Availability</h3>
                  <p className="text-gray-600 text-center">Day or night, we’re standing by—because emergencies don’t keep hours and neither do we.</p>
                </div>
              </FadeIn>
            </section>
    </>
  )
}